import React, { useState } from 'react';

import { Overlay } from '@blueprintjs/core';
import { isDesktop, isMobile, isTablet, useMobileOrientation } from 'react-device-detect';

const Guide = () => {

    const [isOpen, setIsOpen] = useState(false);
    const { isLandscape } = useMobileOrientation();

    function openOverlay() {
        setIsOpen(true);
    }

    return (
        <div className='btn-preview'>
            <button className='main-button3' onClick={() => openOverlay()} title="Vidéo explicative">
                {(isMobile && !isTablet && !isLandscape) && <img className='icone-button-main' src={"https://affichemap.fr/api/uploads/images/question.svg"}></img>}
                {(isDesktop || isTablet || (isMobile && isLandscape)) && "Besoin d'aide ?"}
            </button>
            <Overlay isOpen={isOpen} onClose={() => { setIsOpen(false); }} usePortal={true} portalContainer={document.getElementById('app')!}>
                <div className='video-guide-container'>
                    {<video width="375" autoPlay className='video-guide' controls={true}>
                        <source src="https://affichemap.fr/api/uploads/images/guide_studio.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
    </video>}
                </div>
            </Overlay>
        </div>
    );
};

export default Guide;